// i18n-ресурсы модуля community. Регистрируются через `i18nManager.register('community', ...)`
// в community.client.js (как у orders). Так как ключи в шаблонах начинаются с
// `community.` (`t('community.blog.header')`), внутри каждой локали ОБЯЗАТЕЛЬНО
// повторяется неймспейс `community:` — см. DOCSAI/LOCALIZATION.md.
export default {
  en: {
    community: {
      blog: {
        header: 'Posts for',
        periods: {
          today: 'today',
          week: 'week',
          month: 'month',
          year: 'year',
          all: 'all time',
        },
        categories: {
          featured: 'Featured',
          popular: 'Popular',
          recent: 'Recent',
          following: 'Following',
        },
        createPost: 'Create Post',
        latestComments: 'Latest Comments',
        noCommentsYet: 'No comments yet',
        popularCommunities: 'Popular Communities',
        empty: {
          title: 'No Blog Posts Found',
          description: 'Currently, there are no posts available in this blog. Please check back later.',
        },
        noOrgsFound: 'No Organization Found',
        noOrgsFoundDesc: 'Currently, there are no organization available.',
      },
      comments: {
        title: 'Comments',
        placeholder: 'Write a comment…',
        send: 'Send',
        loginToComment: 'Sign in to leave a comment',
        login: 'Sign in',
        reply: 'Reply',
        cancel: 'Cancel',
        showReplies: 'Show replies',
        hideReplies: 'Hide replies',
        auth: {
          title: 'Join the discussion',
          subtitle: 'Sign in or create an account to comment.',
        },
      },
      auth: {
        title: 'Sign in',
        subtitle: 'Sign in or create an account to continue.',
      },
    },
  },
  ru: {
    community: {
      blog: {
        header: 'Посты за',
        periods: {
          today: 'сегодня',
          week: 'неделю',
          month: 'месяц',
          year: 'год',
          all: 'всё время',
        },
        categories: {
          featured: 'Подборка',
          popular: 'Популярное',
          recent: 'Свежее',
          following: 'Подписки',
        },
        createPost: 'Создать пост',
        latestComments: 'Последние комментарии',
        noCommentsYet: 'Пока нет комментариев',
        popularCommunities: 'Популярные сообщества',
        empty: {
          title: 'Постов пока нет',
          description: 'Здесь пока ничего не опубликовано. Загляните позже.',
        },
        noOrgsFound: 'Организации не найдены',
        noOrgsFoundDesc: 'Сообщества пока недоступны.',
      },
      comments: {
        title: 'Комментарии',
        placeholder: 'Напишите комментарий…',
        send: 'Отправить',
        loginToComment: 'Войдите, чтобы оставить комментарий',
        login: 'Войти',
        reply: 'Ответить',
        cancel: 'Отмена',
        showReplies: 'Показать ответы',
        hideReplies: 'Скрыть ответы',
        auth: {
          title: 'Присоединяйтесь к обсуждению',
          subtitle: 'Войдите или зарегистрируйтесь, чтобы комментировать.',
        },
      },
      auth: {
        title: 'Войдите в аккаунт',
        subtitle: 'Войдите или зарегистрируйтесь, чтобы продолжить.',
      },
    },
  },
};
